import React from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import { Text } from "foundation";
import { Flex } from "@chakra-ui/react";

const logo: string = require("icons/Logo.svg").default;
const name: string = require("icons/Name.svg").default;

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const handleClick = (e: React.SyntheticEvent) => {
    const id: string = e.currentTarget.id;
    switch (id) {
      case "footer-home": {
        navigate("/");
        break;
      }
      case "footer-code": {
        navigate("/coding");
        break;
      }
      case "footer-design": {
        navigate("/design");
        break;
      }
      case "footer-photo": {
        navigate("/photography");
        break;
      }
      case "footer-about": {
        navigate("/about");
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <div className="footer">
      <div className="footer__main content">
        <img src={logo} alt="markcwy Logo" />
        <div className="footer__links">
          <Flex direction="column" gap="0.25rem">
            <Text textStyle="h4">Site Map</Text>
            <Text
              textStyle="h3"
              fontStyle="italic"
              id="footer-about"
              clickable
              onClick={handleClick}
            >
              About
            </Text>
            <Text
              textStyle="h3"
              fontStyle="italic"
              id="footer-code"
              clickable
              onClick={handleClick}
            >
              Coding
            </Text>
            <Text
              textStyle="h3"
              fontStyle="italic"
              id="footer-photo"
              clickable
              onClick={handleClick}
            >
              Photography
            </Text>
            <Text
              textStyle="h3"
              fontStyle="italic"
              id="footer-design"
              clickable
              onClick={handleClick}
            >
              Design
            </Text>
          </Flex>
          <Flex direction="column" gap="0.25rem">
            <Text textStyle="h4">Links</Text>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/markcwy-ra/"
            >
              <Text textStyle="h3" fontStyle="italic" clickable>
                Github
              </Text>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/markcwy/"
            >
              <Text textStyle="h3" fontStyle="italic" clickable>
                LinkedIn
              </Text>
            </a>
          </Flex>
        </div>
      </div>
      <img className="footer__name" src={name} alt="markcwy Logo" />
      <div className="horz-elements content">
        <h5>Code + Design + Photo</h5>
        <h5>©{year} Mark Chan</h5>
      </div>
    </div>
  );
};

export default Footer;
